import React, { useEffect, useState } from 'react'
import { useParams } from 'react-router-dom'
import CustomViewPage from '../../components/CustomComponents/CustomViewPage'
import { useCompany } from '../../hooks/SuperAdmin/useCompany'

import { formatDate, formatTime } from '../../shared/constants'

export default function ViewCompany() {
  const { getCompany, company, loading } = useCompany()
  const params = useParams()

  const [data, setData] = useState([])

  useEffect(() => {
    getCompany({ companyId: params.companyId })
  }, [params.companyId])

  useEffect(() => {
    if (company) {
      setData([
        { label: 'Company Admin Code', data: company.companyAdminCode },
        { label: 'Name', data: `${company.firstName} ${company.lastName}` },
        { label: 'Email', data: company.email },
        { label: 'Phone Number', data: company.phoneNumber },
        { label: 'Date of Birth', data: formatDate(company.dob) },
        { label: 'Total Employees', data: company.employeeCount },
        { label: 'Country', data: company.country },
        { label: 'Reporting Time', data: formatTime(company.reportingTime) },
        { label: 'Leaving Time', data: formatTime(company.leavingTime) },
      ])
    }
  }, [company])
  return <CustomViewPage loading={loading} heading="Company" editUrl="company" id={params.companyId} redirect="ALL_COMPANIES" data={data} />
}
